import { apiRequest, apiResponse } from "@/shared/api/client";

export interface DownloaderTorrent {
  downloader?: string | null;
  hash?: string | null;
  title?: string | null;
  name?: string | null;
  year?: string | null;
  season_episode?: string | null;
  size?: number | null;
  progress?: number | null;
  state?: string | null;
  upspeed?: string | null;
  dlspeed?: string | null;
  left_time?: string | null;
  save_path?: string | null;
}

export interface MediaInfoPayload {
  type?: string | null;
  title?: string | null;
  year?: string | null;
  tmdb_id?: number | null;
  douban_id?: string | null;
  bangumi_id?: number | null;
  poster_path?: string | null;
  [key: string]: unknown;
}

export interface TorrentInfoPayload {
  site?: number | null;
  site_name?: string | null;
  title?: string | null;
  description?: string | null;
  enclosure?: string | null;
  page_url?: string | null;
  size?: number | null;
  seeders?: number | null;
  peers?: number | null;
  labels?: string[] | null;
  volume_factor?: string | null;
  [key: string]: unknown;
}

export function listDownloading() {
  return apiRequest<DownloaderTorrent[]>("/api/v1/download/");
}

export function startDownload(hash: string) {
  return apiResponse(`/api/v1/download/start/${encodeURIComponent(hash)}`);
}

export function stopDownload(hash: string) {
  return apiResponse(`/api/v1/download/stop/${encodeURIComponent(hash)}`);
}

export function removeDownload(hash: string) {
  return apiResponse(`/api/v1/download/${encodeURIComponent(hash)}`, {
    method: "DELETE",
  });
}

/** 添加下载（含媒体信息） */
export function addDownload(
  media_in: MediaInfoPayload,
  torrent_in: TorrentInfoPayload,
) {
  return apiResponse<{ download_id?: string }>("/api/v1/download/", {
    method: "POST",
    body: { media_in, torrent_in },
  });
}
